import Header from '../header/header';
import Footer from '../footer/footer';
import useScrollToHash from '../../hooks/useScrollToHash';

export default function Layout({ headerData, footerData, children }) {
  useScrollToHash();

  return (
    <>
      <Header data={headerData} />
      <main>{children}</main>
      <Footer data={footerData} />
    </>
  );
}
